import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { AngularFireFunctions } from '@angular/fire/functions';
import firebase from 'firebase/app';
import 'firebase/auth';

import { FirebaseCrashlytics } from '@capacitor-community/firebase-crashlytics';
import { BootService } from './boot.service';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  authentication: any = {}
  userData: any = {
    userId: 'visitor'
  }

  card = {
    owner: '',
    number: '',
    date: '',
    cvc: ''
  };
  paypal = { email: '' };
  orange = { phone: '' };
  momo = { phone: '' };

  addrHome: any = null;
  addrWork: any = null;
  addrHistory = [];

  favList = [];
  orderList = [];

  isStarting = true;
  constructor(
    public firestore: AngularFirestore,
    public bootService: BootService,
    private userService: UserService,
    private functions: AngularFireFunctions
  ) {}
  
  // Fill consumer informations (favorites, addresses)
  async fillUserInfo(userData: any, userId: string) {
    console.info ("--- fillUserInfo ---")
    console.log ("userData", userData)
    console.log ("userId", userId)

    this.userData = userData
    this.userData.userId = userId

    //Retrieve User's Favorite data
    this.favList = userData['favorites'] ? userData['favorites'] : [];

    //Retrieve User's Address data
    var addrData = userData['addresses'];
    this.addrHome = addrData ? addrData['home'] : null
    this.addrWork = addrData ? addrData['work'] : null
    this.addrHistory = addrData ? addrData['history'] ? addrData['history'] : [] : []

    // Convert timestamp to date object
    // console.log ("addrHistory", this.addrHistory)
    this.addrHistory.forEach((address: any) => {
      // console.log ("address timestamp", address.timestamp)
      // console.log ("address timestamp", new Date(address.timestamp.seconds))
      address.date = new Date(address.timestamp.seconds * 1000)
    })
  }
  
  // Log user Agent with Firebase funciton
  async logUserAgent() {
    console.info ("--- logUserAgent ---")

    // Call a firebase function which log the user agent message with the user
    const callable = this.functions.httpsCallable('logCall');
    console.log ("firebase.auth().currentUser", firebase.auth().currentUser)
    const title: string = "navigator info"
    const message: any = {
      userId: (firebase.auth().currentUser !== null) ? firebase.auth().currentUser.uid : "visitor",
      userAgent: navigator.userAgent,
      appVersion: navigator.appVersion,
      platform: navigator.platform
    }
    try {
      await callable({title: title, message: JSON.stringify(message)}).toPromise()
    } catch (error) {
      console.error (error)
        
      if (this.bootService.devicePlatform !== 'web') {
        await FirebaseCrashlytics.setUserId({userId: (firebase.auth().currentUser === null) ? 'visitor' : firebase.auth().currentUser.uid})
        await FirebaseCrashlytics.setContext({key: 'page', value: 'user-service', type: 'string'})
        await FirebaseCrashlytics.addLogMessage({message: JSON.stringify(error)})
        await FirebaseCrashlytics.recordException({message: 'Firebase function call | user.service.ts | logUserAgent'})
      }
    }
  }

  /*
  getAddrData() {
    console.info ("--- getAddrData ---")

    this.firestore
      .collection("addresses/").doc(firebase.auth().currentUser.uid)
      .get()
      .subscribe(res => {
        console.log("AddressData", res);
        if (res.exists) {
          let addrData = res.data();
          this.addrHome = addrData ? addrData['home'] : null
          this.addrWork = addrData ? addrData['work'] : null
          this.addrHistory = addrData ? addrData['history'] : []

          console.log ("addrHistory", this.addrHistory)
        }
      });
  }
  */
  updateAddress() {
    console.info ("--- updateAddress ---")
    console.log ("user addresses", this.addrHome)
    console.log ("user addresses", this.addrWork)
    console.log ("user addresses", this.addrHistory)

    if (firebase.auth().currentUser !== null) {
      this.firestore
      .collection("consumers/").doc(firebase.auth().currentUser.uid)
      .update({
        addresses: {
          home: this.addrHome,
          work: this.addrWork,
          history: this.addrHistory
        }
      })
    }
  }

  updateFavlist() {
    console.info ("--- updateFavlist ---")
    console.log ("userService.userData", this.userService.userData)
    if (typeof this.userService.userData === 'undefined' || this.userService.userData.userId === "visitor")
      return

    this.firestore
    .collection("consumers").doc(firebase.auth().currentUser.uid)
    .update({
      favorites: this.favList
    })
  }

  getOrders() {
    console.info ("--- getOrders ---")

    this.firestore.collection("orders", ref => ref.where('consumer.id', '==', firebase.auth().currentUser.uid)).snapshotChanges().subscribe(res => {
      if (res.length > 0) {
        this.orderList = []
        res.map(item => {
          const data = item.payload.doc.data();
          data['id'] = item.payload.doc.id
          this.orderList.push(data);
        })

        this.orderList.sort((a, b) => {
          return b.timestamp - a.timestamp
        })

        console.log ("orders list", this.orderList)
      }
    })
  }

  // Update the user email from menu>profile
  async updateEmail(newEmail: string) {
    console.info ("--- updateEmail ---")

    try {
      await this.firestore
      .collection("consumers")
      .doc(firebase.auth().currentUser.uid)
      .update({email: newEmail})

      this.userData.email = newEmail
    } catch (error) {
      console.error("Firestore error while updating user email", error)
        
      if (this.bootService.devicePlatform !== 'web') {
        await FirebaseCrashlytics.setUserId({userId: (firebase.auth().currentUser === null) ? 'visitor' : firebase.auth().currentUser.uid})
        await FirebaseCrashlytics.setContext({key: 'page', value: 'user-service', type: 'string'})
        await FirebaseCrashlytics.addLogMessage({message: JSON.stringify(error)})
        await FirebaseCrashlytics.recordException({message: 'Firestore update | user.service.ts | updateEmail'})
      }
    }
  }
}
